import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const TakeUpTheCourse = () => {
  return <CommingSoon />;
};

export default TakeUpTheCourse;
